import styled from 'styled-components'

export const StyledProjectsWrapper = styled.div`
  .projects-table {
    &__create-date {
      display: inline-grid;
      justify-content: center;
    }
    &__key-expired {
      display: inline-grid;
      justify-content: end;
    }
  }
  .project-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 25px;
    @media screen and (max-width: 768px) {
      grid-template-columns: max-content 175px;
      grid-gap: 20px;
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
    
    &__create {
      display: inline-grid;
      grid-template-rows: 55px;
      justify-content:  end;
      button {
        height: 100%;
      }
      @media screen and (max-width: 992px) {
        justify-content:  start;
      }
    }
  }
`;